// extracted by mini-css-extract-plugin
export default {"wrap":"RemoteReset_wrap__zludB","tipWrap":"RemoteReset_tipWrap__cUjqs","tipIcon":"RemoteReset_tipIcon__dbWIY"};